import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/a_page_indonesia.jpg")